import styled from "styled-components";

export interface ILanguageSwitcherItemLabelProps {
  isSelected: boolean;
}

export const LanguageSwitcherItemLabelDefaultBox = styled.div<ILanguageSwitcherItemLabelProps>`
  display: flex;
  align-items: center;
  padding: 0.5rem;
  ${({theme}) => theme.font.presets.regular};
  font-size: 1.4rem;
  line-height: 1;
  color: ${props => props.isSelected ? props.theme.colors.brandPrimary : props.theme.colors.text};
  &:hover {
    color: ${props => !props.isSelected && props.theme.colors.textHover};
  }
`;


